import React, { useState, useEffect } from 'react';
import { Code } from 'lucide-react';
import { Badge } from './ui/badge';

const Footer = () => {
  const [visitCount, setVisitCount] = useState(0);

  useEffect(() => {
    // Simular contador de visitas (mock)
    const storedCount = localStorage.getItem('visitCount');
    const currentCount = storedCount ? parseInt(storedCount) + 1 : 1;
    localStorage.setItem('visitCount', currentCount.toString());
    setVisitCount(currentCount);
  }, []);

  return (
    <footer className="bg-black border-t border-green-500/30 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            {/* Brand */}
            <div>
              <h3 className="text-2xl font-bold text-green-400 font-mono mb-4">
                &lt;ORELLANA /&gt;
              </h3>
              <p className="text-gray-400 font-mono text-sm">
                Licenciado en Informática
              </p>
              <p className="text-gray-500 font-mono text-sm mt-2">
                Palpalá, Jujuy, Argentina
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-green-400 font-mono font-bold mb-4">Enlaces rápidos</h4>
              <ul className="space-y-2">
                {['Sobre Mí', 'Formación', 'Servicios', 'Blog', 'El Tesoro', 'Contacto'].map((item) => {
                  let sectionId = item.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '-');
                  if (item === 'El Tesoro') sectionId = 'tesoro';
                  return (
                    <li key={item}>
                      <button
                        onClick={() => document.getElementById(sectionId).scrollIntoView({ behavior: 'smooth' })}
                        className="text-gray-400 hover:text-green-400 transition-colors font-mono text-sm"
                      >
                        {item}
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>

            {/* Technologies */}
            <div>
              <h4 className="text-green-400 font-mono font-bold mb-4">Tecnologías</h4>
              <div className="flex flex-wrap gap-2">
                {['React', 'Python', 'Node.js', 'MongoDB', 'FastAPI', 'PostgreSQL'].map((tech) => (
                  <span
                    key={tech}
                    className="px-3 py-1 bg-green-500/10 border border-green-500/30 rounded text-green-400 font-mono text-xs"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-green-500/20 pt-8">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-6">
              <div className="flex items-center gap-2 text-gray-400 font-mono text-sm">
                <Code size={16} className="text-green-400" />
                <span>Hecho con mis dedos y mate</span>
              </div>
              <p className="text-gray-500 font-mono text-sm">
                © 2026 by ORE. Todos los derechos reservados.
              </p>
            </div>
            
            {/* Visitor Counter */}
            <div className="text-center">
              <Badge 
                variant="outline" 
                className="border-green-500/50 text-green-400 font-mono px-4 py-2 text-sm"
              >
                👁️ Visitas: {visitCount.toLocaleString()}
              </Badge>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;